import React from 'react';
import noop from '../../utils/noop';
export var PopperDropdownContext = React.createContext({
    setToggleRef: noop,
    toggleElement: null,
});
PopperDropdownContext.displayName = 'PopperDropdownContext';
//# sourceMappingURL=PopperDropdownContext.js.map